import { fetchCart } from 'theme';

class CartBarUpsell extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.addEventListener('change', this.onVariantChange);
		this.markCheckedInputFromCart();
	}

	disconnectedCallback() {
		this.removeEventListener('change', this.onVariantChange);
	}

	async markCheckedInputFromCart() {
		const ruleId = this.dataset.ruleId;
		const engine = window.themeConnector?.cartRuleEngine;
		const inputs = [...this.querySelectorAll('input[type="radio"]')];
		if (!ruleId || !engine || inputs.length === 0) return;

		const rule = engine.rules.find((r) => String(r.ruleID) === String(ruleId));
		if (!rule) return;

		const idsFromRule = rule.upsellGiftVariantIds?.filter((id) => Number.isFinite(id)) ?? [];
		const allowedIds = new Set(
			idsFromRule.length > 0
				? idsFromRule
				: inputs.map((input) => parseInt(input.value, 10)).filter((id) => Number.isFinite(id)),
		);

		const cart = await fetchCart;
		let variantInCart = null;
		for (const item of cart?.items ?? []) {
			const vid = parseInt(item.variant_id, 10);
			if (item.quantity > 0 && Number.isFinite(vid) && allowedIds.has(vid)) {
				variantInCart = vid;
				break;
			}
		}

		const engineVariant = parseInt(rule.giftVariantID, 10);
		const firstInputVariant = parseInt(inputs[0]?.value, 10);
		const selected =
			variantInCart ??
			(Number.isFinite(engineVariant) && allowedIds.has(engineVariant) ? engineVariant : null) ??
			(Number.isFinite(firstInputVariant) ? firstInputVariant : null);

		if (selected == null) return;

		for (const input of inputs) {
			input.checked = parseInt(input.value, 10) === selected;
		}
	}

	onVariantChange(event) {
		const input = event.target;
		if (!input?.matches?.('input[type="radio"]') || !input.checked) return;
		const ruleId = this.dataset.ruleId;
		const variantId = input.value;
		const productTitle = input.dataset.productTitle;
		const engine = window.themeConnector?.cartRuleEngine;
		if (!ruleId || !variantId || !engine) return;
		engine.updateRuleGiftVariant(ruleId, variantId, productTitle);
		window.themeConnector?.syncCartAfterUpsellGiftChange?.();
	}
}

if (!window.customElements.get('cart-bar-upsell')) {
	window.customElements.define('cart-bar-upsell', CartBarUpsell);
}
